/* tslint:disable */
/* eslint-disable */
/**
 * Contract Management API
 * API for managing contracts
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Generic response for operations
 * @export
 * @interface OperationResponse1
 */
export interface OperationResponse1 {
    /**
     * Indicates if the operation was successful
     * @type {boolean}
     * @memberof OperationResponse1
     */
    isSuccess?: boolean;
    /**
     * Return message (success or error)
     * @type {string}
     * @memberof OperationResponse1
     */
    message?: string | null;
    /**
     * Detailed error message in case of failure
     * @type {string}
     * @memberof OperationResponse1
     */
    errorMessage?: string | null;
}

/**
 * Check if a given object implements the OperationResponse1 interface.
 */
export function instanceOfOperationResponse1(value: object): value is OperationResponse1 {
    return true;
}

export function OperationResponse1FromJSON(json: any): OperationResponse1 {
    return OperationResponse1FromJSONTyped(json, false);
}

export function OperationResponse1FromJSONTyped(json: any, ignoreDiscriminator: boolean): OperationResponse1 {
    if (json == null) {
        return json;
    }
    return {
        
        'isSuccess': json['isSuccess'] == null ? undefined : json['isSuccess'],
        'message': json['message'] == null ? undefined : json['message'],
        'errorMessage': json['errorMessage'] == null ? undefined : json['errorMessage'],
    };
}

export function OperationResponse1ToJSON(json: any): OperationResponse1 {
    return OperationResponse1ToJSONTyped(json, false);
}

export function OperationResponse1ToJSONTyped(value?: OperationResponse1 | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'isSuccess': value['isSuccess'],
        'message': value['message'],
        'errorMessage': value['errorMessage'],
    };
}

